var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CategoryDetail"},_vm._l((_vm.secondCategories),function(secondCategory,index){return _c('Panel',{key:index,attrs:{"secondCategory":secondCategory,"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }